/**
 * @desc 合作伙伴
 */
import { PartnerController } from './parter';
import { StayDataController } from './stayData';
export class CooperateController {
  /** 合作伙伴查询 */
  PartnerController = new PartnerController();
  /** 留资 */
  StayDataController = new StayDataController();
}
